// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "NavCard-module--wrapper--qkYyV";
export var inner = "NavCard-module--inner--+sZWS";
export var imageWrapper = "NavCard-module--imageWrapper--+bO0w";
export var title = "NavCard-module--title--mXMLD";
export var description = "NavCard-module--description--I5V5R";
export var button = "NavCard-module--button--o0Vfk";
export var text = "NavCard-module--text--ET7r1";